import { TranslationKeys } from '../TranlsationKeys';

type BadgeType = Extract<
  TranslationKeys,
  `golfCourseBadge.${string}`
> extends `golfCourseBadge.${infer K}`
  ? K
  : never;

const badgeOrder: BadgeType[] = ['discount', 'promoted', 'recommended', 'topBooked', 'topRated'];

export const getActiveBadge = (badges: Partial<Record<BadgeType, boolean>>): BadgeType | null => {
  return badgeOrder.find(badge => badges[badge]) || null;
};
